import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_VOUCHER_LISTING,
    ADD_VOUCHER,
    UPDATE_VOUCHER,
    DELETE_VOUCHER,
    EXPORT_VOUCHER,
    GET_VOUCHER_DETAILS,
} from "./actionTypes.js";

import {
    getVoucherListingSuccess,
    getVoucherListingFail,
    createVoucherSuccess,
    createVoucherFail,
    updateVoucherSuccess,
    updateVoucherFail,
    deleteVoucherSuccess,
    deleteVoucherFail,
    exportVoucherSuccess,
    exportVoucherFail,
    getVoucherDetailsSuccess,
    getVoucherDetailsFail,
} from "./actions.js";

import {
    voucherListingApi,
    voucherDetailsApi,
    addVoucherApi,
    updateVoucherApi,
    deleteVoucherApi,
    exportVoucherApi,
} from "./voucherApi.js";

function* fetchVoucherListing({ payload }) {
    try {
        const response = yield call(voucherListingApi, payload);
        yield put(getVoucherListingSuccess(response));
    } catch (error) {
        yield put(getVoucherListingFail(error));
    }
}

function* fetchVoucherDetail({ payload }) {
    try {
        const response = yield call(voucherDetailsApi, payload);
        yield put(getVoucherDetailsSuccess(response));
    } catch (error) {
        yield put(getVoucherDetailsFail(error));
    }
}

function* createVoucher({ payload }) {
    try {
        const response = yield call(addVoucherApi, payload);
        yield put(createVoucherSuccess(response));
    } catch (error) {
        yield put(createVoucherFail(error));
    }
}

function* updateVoucher({ payload }) {
    try {
        const response = yield call(updateVoucherApi, payload);
        yield put(updateVoucherSuccess(response));
    } catch (error) {
        yield put(updateVoucherFail(error));
    }
}

function* deleteVoucher({ payload }) {
    try {
        const response = yield call(deleteVoucherApi, payload);
        yield put(deleteVoucherSuccess(response));
    } catch (error) {
        yield put(deleteVoucherFail(error));
    }
}

function* exportVoucher({ payload }) {
    try {
        const response = yield call(exportVoucherApi, payload);
        yield put(exportVoucherSuccess(response));
    } catch (error) {
        yield put(exportVoucherFail(error));
    }
}

function* VoucherSaga() {
    yield takeEvery(GET_VOUCHER_LISTING, fetchVoucherListing);
    yield takeEvery(GET_VOUCHER_DETAILS, fetchVoucherDetail);
    yield takeEvery(ADD_VOUCHER, createVoucher);
    yield takeEvery(UPDATE_VOUCHER, updateVoucher);
    yield takeEvery(DELETE_VOUCHER, deleteVoucher);
    yield takeEvery(EXPORT_VOUCHER, exportVoucher);

}

export default VoucherSaga
